import { useState } from "react"
import { useTranslation } from 'react-i18next'
import Icon from "../Icons"
import LabelInput from "../LabelInput"
import "./index.scss"

const TablePagination = ({
    pageCount = 0,
    canNextPage = false,
    canPreviousPage = false,
    pageIndex, pageOptions, pageJump = true,
    pageSize, setPageSize, pageLimit = false,
    gotoPage, previousPage, nextPage, recordsOnPage
}) => {
    const [jumpOn, setJumpOn] = useState(pageIndex + 1)
    const fromRec = (pageIndex * 10)
    const uptoRec = fromRec + recordsOnPage
    const { t } = useTranslation()

    const goToPageCall = pageNumber => {
        if (pageNumber > pageOptions.length) {
            setJumpOn(pageOptions.length - 1)
            gotoPage(pageOptions.length - 1)
        } else if (pageNumber < 1) {
            setJumpOn(1)
            gotoPage(pageNumber)
        } else {
            gotoPage(pageNumber)
        }
    }

    return (
        <div className="waywize-table-pagination center-flex">
            <button onClick={() => previousPage()} disabled={!canPreviousPage}><Icon name="left-arrow" /></button>
            <span className="ml-9 mr-9"><strong>{fromRec + 1} - {uptoRec}</strong>{' '}</span>
            <button onClick={() => nextPage()} disabled={!canNextPage}><Icon name="right-arrow" /></button>
            {!!pageJump && <div className="go-to-page-sec center-flex">
                <span className="ml-20 mr-20">{t('table.go_to_pg')}</span>
                <LabelInput showLabel={false} type="number" value={jumpOn}
                    onChange={e => {
                        setJumpOn((e.target.value ? Number(e.target.value) - 1 : 0) + 1)
                    }} />
                <button onClick={() => goToPageCall(jumpOn)} className="ml-10"><Icon name="right-arrow" /></button>
            </div>}
            {!!pageLimit && !!pageSize && !!setPageSize && <select
                value={pageSize}
                onChange={e => {
                    !!setPageSize && setPageSize(Number(e.target.value))
                }}
            >
                {[10, 20, 30, 40, 50].map(pageSize => (
                    <option key={pageSize} value={pageSize}>
                        Show {pageSize}
                    </option>
                ))}
            </select>}
        </div>
    )
}

export default TablePagination